import { render } from "./pay_success.vue?vue&type=template&id=3c651170&scoped=true&ts=true"
import script from "./pay_success.vue?vue&type=script&lang=ts"
export * from "./pay_success.vue?vue&type=script&lang=ts"

import "./pay_success.vue?vue&type=style&index=0&id=3c651170&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c651170"]])

export default __exports__